import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconCallRingHugeicons = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M10 3.33337V5.83337M15 5.83337L13.3333 7.50004M5 5.83337L6.66667 7.50004",
			stroke: "url(#paint0_radial_3922_28116)",
			strokeWidth: 1.4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.2677 14.3703L13.2759 14.4187C13.3714 14.9838 13.4191 15.2665 13.5674 15.4948C13.6116 15.5627 13.6619 15.6265 13.7178 15.6851C13.9055 15.8822 14.1691 15.9936 14.6964 16.2165C15.4886 16.5514 15.8847 16.7189 16.2647 16.6523C16.3763 16.6327 16.4849 16.5987 16.5878 16.5511C16.938 16.3891 17.1709 16.0216 17.6364 15.2867C18.1221 14.5202 18.3649 14.137 18.3301 13.6997C18.3223 13.6016 18.2968 13.4773 18.2654 13.3842C18.1254 12.9684 17.7961 12.7428 17.1378 12.2915C12.6807 9.23617 7.31934 9.23617 2.8623 12.2915C2.20391 12.7428 1.87472 12.9684 1.73464 13.3842C1.70325 13.4773 1.67777 13.6016 1.66997 13.6997C1.63516 14.137 1.87797 14.5202 2.36359 15.2867C2.82922 16.0216 3.06204 16.3891 3.41229 16.5511C3.51515 16.5987 3.62374 16.6327 3.73532 16.6523C4.11531 16.7189 4.51144 16.5514 5.30371 16.2165C5.8309 15.9936 6.09449 15.8822 6.28227 15.6851C6.33814 15.6265 6.38846 15.5627 6.4326 15.4948C6.58096 15.2665 6.62871 14.9838 6.72421 14.4187L6.73238 14.3703C6.83095 13.7868 6.88024 13.4951 7.09641 13.2276C7.12666 13.1902 7.1817 13.1308 7.2167 13.0978C7.46686 12.8618 7.68762 12.8072 8.12912 12.6979C9.31827 12.4035 10.6818 12.4035 11.8709 12.6979C12.3124 12.8072 12.5332 12.8618 12.7834 13.0978C12.8184 13.1308 12.8734 13.1902 12.9036 13.2276C13.1198 13.4951 13.1691 13.7868 13.2677 14.3703Z",
			stroke: "url(#paint1_radial_3922_28116)",
			strokeWidth: 1.4,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("radialGradient", {
			id: "paint0_radial_3922_28116",
			cx: 0,
			cy: 0,
			r: 1,
			gradientTransform: "matrix(10.0829 1.42065 -27.3128 33.6543 5.99241 5.02675)",
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .0671246,
					stopColor: "#9168C0"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .342551,
					stopColor: "#5684D1"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .672076,
					stopColor: "#1E3FC0"
				})
			]
		}), /* @__PURE__ */ _jsxs("radialGradient", {
			id: "paint1_radial_3922_28116",
			cx: 0,
			cy: 0,
			r: 1,
			gradientTransform: "matrix(16.8048 2.27305 -45.5214 53.8469 3.32071 12.7094)",
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .0671246,
					stopColor: "#9168C0"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .342551,
					stopColor: "#5684D1"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .672076,
					stopColor: "#1E3FC0"
				})
			]
		})] })
	]
});
const ForwardRef = forwardRef(SvgIconCallRingHugeicons);
export { ForwardRef as ReactComponent };
